/**
 * Junk news "thumbnails" — images that exist but don't represent the article:
 * tracking pixels, WordPress emoji images (s.w.org — the infamous ™ tile),
 * site logos, avatars, default/placeholder og images.
 *
 * Shared by the industry-news scraper (so junk never gets stored as the
 * article image) and the /news listing (so the ~2.5k already-stored docs are
 * cleaned up at render time without a data migration).
 */
export const JUNK_NEWS_IMG =
  /feedburner|feedsportal|doubleclick|\bpixel\b|\/stats?[.\/?]|wp\.com\/b\.gif|gravatar\.com|feedblitz|mc\.yandex|facebook\.com\/tr|\b1x1\b|spacer|s\.w\.org\/images\/core\/emoji|\/emoji\/|twemoji|[-_/]logos?[-_.\/]|\/avatars?\/|default[-_]?og|og[-_]?default|placeholder/i;

/** True when the URL is a real, representative article thumbnail. */
export function hasRealNewsThumb(url?: string | null): boolean {
  return !!url && /^https?:\/\//i.test(url) && !JUNK_NEWS_IMG.test(url);
}

/**
 * Safe article href. Legacy Squarespace slugs contain slashes
 * ("2025/7/2/one-is-patch") which can never match the single-segment
 * /news/[slug] route (the card 404s). getNewsBySlug resolves doc IDs first,
 * so slash-slugged articles link by ID instead.
 */
export function newsHref(a: { slug?: string; id?: string }): string {
  const slug = String(a.slug || "");
  const safe = slug && !slug.includes("/") ? slug : (a.id || slug);
  return `/news/${safe}`;
}
